import React from 'react'
import { TextField } from '@material-ui/core'

function ExtraInputField({ label, id, onChange, required, value }) {
  const handleChange = (event) => {
    onChange(event.target.value)
  }

  // make sure that the input field has red border if required and empty
  return (
    <TextField
      label={label}
      id={id}
      onChange={handleChange}
      fullWidth
      margin="normal"
      required={required}
      error={required && !value}
      InputProps={{
        style: {
          borderColor: required && !value ? 'red' : undefined,
        },
      }}
    />
  )
}

export default ExtraInputField
